import { ColDef } from 'ag-grid-community';

export class GridColDefsSeguridad{

  public columnDefs: ColDef[] = [
    { headerName: "Nombre del dosier", field: "nombre", sortable: true, filter: true, headerClass: "header", wrapText: true, autoHeight: true, checkboxSelection: true, width: 500 }
  ]

}
